export function vypocitajFinCloudTip(suma, roky, zostatky) {
  const S = Math.max(0, Number(suma) || 0);
  const R = Math.max(0, Number(roky) || 0);

  if (!S || R < 15) return null;
  if (!Array.isArray(zostatky) || zostatky.length === 0) return null;

  const rocneZhodnotenie = 0.06;
  const r = rocneZhodnotenie / 12;

  const rokyTriStvrtiny = Math.max(1, Math.round(R * 0.75));
  const rokyPolovica = Math.max(1, Math.round(R * 0.5));

  const zostatokPoRokoch = (rokyCiel) => {
    const idx = Math.max(0, Math.round(rokyCiel) * 12 - 1); // zostatok po t mesiacoch (po splátke)
    const val = zostatky[idx];
    return Math.max(0, Number(val) || 0);
  };

  const mesacnyVklad = (cielovaSuma, rokyCiel) => {
    const FV = Math.max(0, Number(cielovaSuma) || 0);
    if (!FV) return 0;

    const n = Math.max(1, Math.round(rokyCiel) * 12);
    const a = Math.pow(1 + r, n);
    const pmt = (FV * r) / (a - 1);

    // "aspoň" => zaokrúhliť NAHOR
    return Math.ceil(pmt);
  };

  const sablona = {
    pred: 'Investujte ',
    pred2: ' mesačne ',
    stred: ' a hypotéku môžete splatiť ',
    za: ' o ',
    za2: ' rokov skôr',
  };

  const priebehInvesticie = (mesacne, celkovoRokov) => {
    const n = Math.max(1, Math.round(celkovoRokov) * 12);
    const vklad = Math.max(0, Number(mesacne) || 0);

    let stav = 0;
    const priebeh = new Array(n).fill(0);

    for (let m = 1; m <= n; m++) {
      stav += vklad;
      stav *= (1 + r);
      priebeh[m - 1] = stav;
    }

    return priebeh;
  };

  const tipyKandidati = [
    { faza: "TRI_STVRTINY", rokyCiel: rokyTriStvrtiny, zostatok: zostatokPoRokoch(rokyTriStvrtiny) },
    { faza: "POLOVICA", rokyCiel: rokyPolovica, zostatok: zostatokPoRokoch(rokyPolovica) },
  ];

  const tipy = tipyKandidati.map((t) => {
    const mesacne = mesacnyVklad(t.zostatok, t.rokyCiel);
    const usetreneRoky = Math.max(0, Math.round(R - t.rokyCiel));

    return {
      faza: t.faza,
      rokyCiel: t.rokyCiel,
      mesacne,
      usetreneRoky,
      priebehKrivky: priebehInvesticie(mesacne, R),
    };
  });

  // MUSIA byť presne 2 tipy, inak sa nezobrazuje nič
  const suValidne = tipy.length === 2 && tipy.every((t) => (t.mesacne > 0) && (t.usetreneRoky > 0));

  if (!suValidne) return null;

  return { sablona, tipy };
}